module.exports = __webpack_public_path__ + "img/Group 505.723f984c.png";